var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTestimonial = function SvgTestimonial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__a)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.535.463H.511v65.074h65.024V.463Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.517 0c0 18.19-14.538 32.94-32.513 32.94C15.03 32.94.566 18.228.566 0M65.87 32.977H0M13.413 54.517c2.848 0 5.156-2.299 5.156-5.135s-2.308-5.135-5.156-5.135c-2.847 0-5.155 2.299-5.155 5.135s2.308 5.135 5.155 5.135ZM32.94 54.517c2.847 0 5.155-2.299 5.155-5.135s-2.308-5.135-5.155-5.135c-2.848 0-5.156 2.299-5.156 5.135s2.308 5.135 5.156 5.135ZM52.456 54.517c2.848 0 5.156-2.299 5.156-5.135s-2.308-5.135-5.156-5.135c-2.847 0-5.155 2.299-5.155 5.135s2.308 5.135 5.155 5.135Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__b)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.478.518v65.02h67.035V.518H65.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.478 33.023c4.407.005 8.77.85 12.84 2.486a33.65 33.65 0 0 1 10.88 7.053 32.415 32.415 0 0 1 7.26 10.545 31.554 31.554 0 0 1 2.537 12.43M99.005.518a31.557 31.557 0 0 1-2.541 12.43A32.416 32.416 0 0 1 89.2 23.49a33.651 33.651 0 0 1-10.881 7.05 34.535 34.535 0 0 1-12.841 2.483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.465 65.538V.462H65.478v65.076h66.987Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.464 32.995a34.532 34.532 0 0 1-12.836-2.496 33.644 33.644 0 0 1-10.871-7.06 32.424 32.424 0 0 1-7.253-10.547A31.56 31.56 0 0 1 98.976.462M98.966 65.538a31.57 31.57 0 0 1 2.529-12.434 32.423 32.423 0 0 1 7.255-10.55 33.657 33.657 0 0 1 10.874-7.062 34.542 34.542 0 0 1 12.84-2.497"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__c)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.542.462h-64.084v65.075h64.084V.462Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.542 30.812c0 19.01-14.345 34.42-32.06 34.42-17.716 0-32.024-15.41-32.024-34.42M196.46 33.014h-63.946M132.403.324l32.125 32.486M196.634.324 164.519 32.8M168.021 19.738a5.122 5.122 0 0 0-.345-7.186 5.003 5.003 0 0 0-7.116.347c-1.87 2.08-1.716 5.298.344 7.187a5.004 5.004 0 0 0 7.117-.348Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__d)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.462 32.986h-15.858M277.452 32.986h-15.627M276.291 35.314a20.225 20.225 0 0 0-.299 19.049 20.456 20.456 0 0 0 6.487 7.42 20.719 20.719 0 0 0 9.237 3.561c.706.099 1.418.16 2.131.18h-32.368V.476h33.117l-17.077 32.501-1.228 2.338Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.52.475v65.04h-32.252a19.014 19.014 0 0 0 2.102-.17 20.746 20.746 0 0 0 9.306-3.645 20.48 20.48 0 0 0 6.479-7.551 20.258 20.258 0 0 0 2.127-9.682 20.269 20.269 0 0 0-2.727-9.533l-.048-.105-.96-1.853-16.951-32.5h32.924Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.824 65.278h-3.148v.484h3.148v-.484Z",
    fill: "#fff",
    strokeWidth: 0.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__e)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.746 22.339c2.728 0 2.728 5.648 5.446 5.648 2.719 0 2.728-5.648 5.456-5.648s2.718 5.648 5.437 5.648c2.718 0 2.727-5.648 5.455-5.648s2.719 5.648 5.446 5.648c2.728 0 2.728-5.648 5.447-5.648 2.718 0 2.727 5.648 5.455 5.648s2.719-5.648 5.446-5.648c2.728 0 2.728 5.648 5.447 5.648 2.718 0 2.727-5.648 5.455-5.648s2.728 5.648 5.456 5.648 2.728-5.648 5.456-5.648M327.746 13.368c2.728 0 2.728 5.648 5.446 5.648 2.719 0 2.728-5.648 5.456-5.648s2.718 5.648 5.437 5.648c2.718 0 2.727-5.648 5.455-5.648s2.719 5.648 5.446 5.648c2.728 0 2.728-5.648 5.447-5.648 2.718 0 2.727 5.648 5.455 5.648s2.719-5.648 5.446-5.648c2.728 0 2.728 5.648 5.447 5.648 2.718 0 2.727-5.648 5.455-5.648s2.728 5.648 5.456 5.648 2.728-5.648 5.456-5.648M327.746 5.328c2.718 0 2.718 5.648 5.446 5.648 2.728 0 2.728-5.648 5.446-5.648 2.719 0 2.728 5.648 5.447 5.648 2.718 0 2.727-5.648 5.446-5.648 2.718 0 2.728 5.648 5.446 5.648 2.718 0 2.728-5.648 5.456-5.648 2.727 0 2.718 5.648 5.446 5.648 2.728 0 2.728-5.648 5.455-5.648 2.728 0 2.719 5.648 5.447 5.648 2.727 0 2.727-5.648 5.455-5.648s2.728 5.648 5.456 5.648 2.728-5.648 5.456-5.648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.521.47h-66.042v65.06h66.042V.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.512 33.042c0 17.491-14.769 31.668-32.993 31.668-18.224 0-32.983-14.177-32.983-31.667M327.642 33.005h65.669"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__f)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.529.471h-65.057V65.53h65.057V.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.321 33a32.211 32.211 0 0 1-20.049 29.672 32.218 32.218 0 0 1-12.347 2.385 32.214 32.214 0 0 1-29.881-19.736A32.212 32.212 0 0 1 393.528 33M393.528 32.962h64.793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.538 33A32.206 32.206 0 0 1 425.925.943a32.215 32.215 0 0 1 29.881 19.736A32.212 32.212 0 0 1 458.322 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.204 33a26.72 26.72 0 1 1 53.441 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.88 33a21.043 21.043 0 1 1 42.089 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.557 33a15.377 15.377 0 0 1 30.746 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.232 33a9.704 9.704 0 0 1 9.698-9.4 9.702 9.702 0 0 1 9.697 9.4"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__g)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523.529.471h-65.057V65.53h65.057V.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.529.443A32.526 32.526 0 0 1 491 32.972 32.528 32.528 0 0 1 458.472.443"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.491 32.925a32.491 32.491 0 1 1-64.981 0M523.689 33h-65.161"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__h)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.471.478v65.025h65.057V.478h-65.057Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.179.675c19.339 0 35.002 14.512 35.002 32.428 0 17.916-15.663 32.428-35.002 32.428M196.782 32.981h34.767M232.105 65.09V.948M238.335.947V65.09M244.555.947V65.08M250.784.947V65.08M257.005.947V65.08"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__i)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1243.54.463h-65.03v65.074h65.03V.463Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.52 0c0 18.19-14.54 32.94-32.52 32.94-17.97 0-32.43-14.712-32.43-32.94M1243.87 32.977H1178M1191.41 54.517c2.85 0 5.16-2.299 5.16-5.135s-2.31-5.135-5.16-5.135c-2.84 0-5.15 2.299-5.15 5.135s2.31 5.135 5.15 5.135ZM1210.94 54.517c2.85 0 5.16-2.299 5.16-5.135s-2.31-5.135-5.16-5.135-5.16 2.299-5.16 5.135 2.31 5.135 5.16 5.135ZM1230.46 54.517c2.84 0 5.15-2.299 5.15-5.135s-2.31-5.135-5.15-5.135c-2.85 0-5.16 2.299-5.16 5.135s2.31 5.135 5.16 5.135Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__j)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1243.46.518v65.02h65.07V.518h-65.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.46 33.023c4.28.005 8.52.85 12.47 2.486a32.678 32.678 0 0 1 10.56 7.053 32.43 32.43 0 0 1 7.04 10.545 32.535 32.535 0 0 1 2.47 12.43M1276 .518c.01 4.264-.83 8.488-2.46 12.43a32.445 32.445 0 0 1-7.05 10.542 32.56 32.56 0 0 1-10.56 7.05 32.68 32.68 0 0 1-12.47 2.483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.48 65.538V.462h-65.02v65.076h65.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.48 32.995a32.658 32.658 0 0 1-12.46-2.496 32.566 32.566 0 0 1-10.55-7.06 32.455 32.455 0 0 1-7.04-10.547 32.328 32.328 0 0 1-2.45-12.43M1275.97 65.538c-.01-4.265.82-8.49 2.45-12.434a32.464 32.464 0 0 1 7.04-10.55 32.65 32.65 0 0 1 23.02-9.558"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__k)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1374.53.462h-66.06v65.075h66.06V.462Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.53 30.812c0 19.01-14.79 34.42-33.05 34.42-18.26 0-33.01-15.41-33.01-34.42M1374.44 33.014h-65.91M1308.42.324l33.11 32.486M1374.62.324l-33.1 32.477M1345.13 19.738a5.008 5.008 0 0 0-.36-7.186c-2.12-1.889-5.4-1.733-7.33.347a5.016 5.016 0 0 0 .35 7.187c2.13 1.888 5.41 1.733 7.34-.348Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__l)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1374.47.478v65.025h65.06V.478h-65.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.18.675c19.34 0 35 14.512 35 32.428 0 17.916-15.66 32.428-35 32.428M1374.78 32.981h34.77M1410.11 65.09V.948M1416.33.947V65.09M1422.55.947V65.08M1428.78.947V65.08M1435 .947V65.08"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__m)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.528.471h-65.056V65.53h65.056V.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.575 33.085a32.376 32.376 0 0 1 9.5-22.908A32.451 32.451 0 0 1 556.009.688a32.453 32.453 0 0 1 22.934 9.489 32.38 32.38 0 0 1 9.499 22.908"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.443 33a32.407 32.407 0 0 1-9.7 22.57 32.48 32.48 0 0 1-22.757 9.302 32.482 32.482 0 0 1-22.758-9.302 32.407 32.407 0 0 1-9.7-22.57M523.575 33h64.764"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__n)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M655.521.463h-66.995v65.074h66.995V.463Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.502 0c0 18.19-14.978 32.94-33.497 32.94S588.584 18.228 588.584 0M655.866 32.977H588M601.821 54.517c2.933 0 5.311-2.299 5.311-5.135s-2.378-5.135-5.311-5.135c-2.934 0-5.312 2.299-5.312 5.135s2.378 5.135 5.312 5.135ZM621.938 54.517c2.933 0 5.311-2.299 5.311-5.135s-2.378-5.135-5.311-5.135c-2.934 0-5.312 2.299-5.312 5.135s2.378 5.135 5.312 5.135ZM642.046 54.517c2.934 0 5.312-2.299 5.312-5.135s-2.378-5.135-5.312-5.135c-2.933 0-5.312 2.299-5.312 5.135s2.379 5.135 5.312 5.135Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__o)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M655.464.518v65.02h65.063V.518h-65.063Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.464 33.023c4.278.005 8.513.85 12.463 2.486a32.577 32.577 0 0 1 10.559 7.053 32.45 32.45 0 0 1 7.047 10.545 32.378 32.378 0 0 1 2.463 12.43M688.005.518a32.376 32.376 0 0 1-2.466 12.43 32.476 32.476 0 0 1-7.05 10.542 32.578 32.578 0 0 1-10.562 7.05 32.652 32.652 0 0 1-12.463 2.483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.48 65.538V.462h-65.017v65.076h65.017Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.48 32.995a32.651 32.651 0 0 1-12.458-2.496 32.575 32.575 0 0 1-10.552-7.06 32.468 32.468 0 0 1-7.039-10.547 32.37 32.37 0 0 1-2.454-12.43M687.968 65.538a32.388 32.388 0 0 1 2.455-12.434 32.467 32.467 0 0 1 7.041-10.55 32.587 32.587 0 0 1 10.555-7.062 32.664 32.664 0 0 1 12.462-2.497"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__p)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M784.542.462h-64.084v65.075h64.084V.462Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.542 30.812c0 19.01-14.345 34.42-32.06 34.42-17.716 0-32.024-15.41-32.024-34.42M784.46 33.014h-63.946M720.403.324l32.125 32.486M784.634.324 752.519 32.8M756.021 19.738a5.122 5.122 0 0 0-.345-7.186 5.003 5.003 0 0 0-7.116.347c-1.87 2.08-1.716 5.298.344 7.187a5.004 5.004 0 0 0 7.117-.348Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__q)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M916.47 32.986h-15.62M867.207 32.986h-15.394M866.063 35.314a20.484 20.484 0 0 0-.295 19.049 20.376 20.376 0 0 0 6.391 7.42 20.231 20.231 0 0 0 9.099 3.561c.696.099 1.396.16 2.099.18h-31.884V.476h32.621l-16.821 32.501-1.21 2.338ZM916.527.475v65.04h-31.77a18.425 18.425 0 0 0 2.07-.17 20.259 20.259 0 0 0 9.168-3.645 20.391 20.391 0 0 0 6.382-7.551 20.503 20.503 0 0 0-.591-19.215l-.047-.105-.946-1.853-16.698-32.5h32.432Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.305 65.278h-3.102v.484h3.102v-.484Z",
    fill: "#fff",
    strokeWidth: 0.5
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__r)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M916.735 22.339c2.687 0 2.687 5.648 5.365 5.648 2.678 0 2.687-5.648 5.374-5.648 2.688 0 2.678 5.648 5.356 5.648s2.687-5.648 5.374-5.648 2.678 5.648 5.365 5.648c2.687 0 2.687-5.648 5.365-5.648 2.678 0 2.687 5.648 5.374 5.648s2.678-5.648 5.365-5.648c2.687 0 2.687 5.648 5.365 5.648 2.678 0 2.687-5.648 5.374-5.648s2.687 5.648 5.374 5.648c2.688 0 2.688-5.648 5.375-5.648M916.735 13.368c2.687 0 2.687 5.648 5.365 5.648 2.678 0 2.687-5.648 5.374-5.648 2.688 0 2.678 5.648 5.356 5.648s2.687-5.648 5.374-5.648 2.678 5.648 5.365 5.648c2.687 0 2.687-5.648 5.365-5.648 2.678 0 2.687 5.648 5.374 5.648s2.678-5.648 5.365-5.648c2.687 0 2.687 5.648 5.365 5.648 2.678 0 2.687-5.648 5.374-5.648s2.687 5.648 5.374 5.648c2.688 0 2.688-5.648 5.375-5.648M916.735 5.328c2.678 0 2.678 5.648 5.365 5.648 2.687 0 2.687-5.648 5.365-5.648 2.678 0 2.687 5.648 5.365 5.648 2.678 0 2.687-5.648 5.365-5.648 2.677 0 2.687 5.648 5.365 5.648 2.677 0 2.687-5.648 5.374-5.648s2.678 5.648 5.365 5.648c2.687 0 2.687-5.648 5.374-5.648s2.678 5.648 5.365 5.648c2.687 0 2.687-5.648 5.374-5.648s2.687 5.648 5.374 5.648c2.688 0 2.688-5.648 5.375-5.648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.529.47h-65.057v65.06h65.057V.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.519 33.042c0 17.491-14.548 31.668-32.5 31.668-17.952 0-32.491-14.177-32.491-31.667M916.632 33.005h64.689"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__s)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1046.53.471h-65.058V65.53h65.058V.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.32 33c-.02 4.233-.87 8.42-2.51 12.321a32.356 32.356 0 0 1-7.04 10.42 32.25 32.25 0 0 1-22.85 9.316A32.212 32.212 0 0 1 981.528 33M981.528 32.962h64.792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.538 33A32.206 32.206 0 0 1 1013.93.943a32.251 32.251 0 0 1 22.84 9.316c3 2.977 5.4 6.518 7.04 10.42A32.188 32.188 0 0 1 1046.32 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.204 33a26.72 26.72 0 0 1 45.616-18.894A26.729 26.729 0 0 1 1040.65 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.88 33a21.043 21.043 0 0 1 21.04-21.045c5.59 0 10.94 2.217 14.89 6.164 3.94 3.947 6.16 9.3 6.16 14.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.557 33a15.384 15.384 0 0 1 4.633-10.627 15.382 15.382 0 0 1 21.48 0A15.386 15.386 0 0 1 1029.3 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.23 33a9.714 9.714 0 0 1 9.7-9.4 9.714 9.714 0 0 1 9.7 9.4"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__t)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112.52.471h-66.04V65.53h66.04V.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.52.443c0 8.627-3.48 16.901-9.67 23.001-6.19 6.1-14.59 9.528-23.35 9.528-8.76 0-17.16-3.427-23.35-9.528-6.19-6.1-9.67-14.374-9.67-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.48 32.925c0 8.617-3.47 16.88-9.66 22.974-6.18 6.093-14.57 9.516-23.32 9.516s-17.14-3.423-23.32-9.516c-6.19-6.093-9.66-14.357-9.66-22.974M1112.68 33h-66.14"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__u)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M784.485.478v65.025h67.029V.478h-67.029Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.185.675c19.925 0 36.063 14.512 36.063 32.428 0 17.916-16.138 32.428-36.063 32.428M784.806 32.981h35.82M821.199 65.09V.948M827.618.947V65.09M834.026.947V65.08M840.445.947V65.08M846.854.947V65.08"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#testimonial_svg__v)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1178.52.471h-66.04V65.53h66.04V.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.58 33.085c0-8.592 3.47-16.832 9.65-22.908 6.17-6.076 14.55-9.489 23.28-9.489s17.11 3.413 23.28 9.489c6.18 6.076 9.65 14.316 9.65 22.908"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.44 33c-.15 8.503-3.69 16.608-9.85 22.57-6.16 5.961-14.46 9.302-23.1 9.302-8.65 0-16.94-3.34-23.11-9.302-6.16-5.962-9.7-14.067-9.84-22.57M1112.58 33h65.75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(65)",
    d: "M0 0h68v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(132)",
    d: "M0 0h65v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(261)",
    d: "M0 0h67v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(327)",
    d: "M0 0h67v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(393)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(458)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(196)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1178)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1243)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1308)",
    d: "M0 0h67v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1374)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__m"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(523)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(588)",
    d: "M0 0h68v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(655)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__p"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(720)",
    d: "M0 0h65v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__q"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(851)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__r"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(916)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__s"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(981)",
    d: "M0 0h66v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__t"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1046)",
    d: "M0 0h67v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__u"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(784)",
    d: "M0 0h68v66H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "testimonial_svg__v"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1112)",
    d: "M0 0h67v66H0z"
  })))));
};

export { SvgTestimonial as ReactComponent };
export default __webpack_public_path__ + "static/testimonial.e9a1c5e4.svg";